// extracted by mini-css-extract-plugin
export default {"schedule":"schedule-MDxCTGVIZeuMjpsYB79Y","realtime":"realtime-jlmmbPd407dBNVbhx76i","icon":"icon-RDxZU_RDpanZmZlAC4qg","pulse":"pulse-sCvrdmKKcsSZhUODEodI"};